module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/02-1f5ce966493625566ebab2b1a5649c70.png";